import { useTranslation } from 'react-i18next';

import { Link, Stack } from '@mui/material';

import { i18nNS } from '../../../i18n';
import Layout from '../Layout';
import { BackButton, LoginButton, StyledPasswordTextField } from './styles';
import useLoginPasswordVM from './vm';
import Typography from '../../../components/Typography';

const LoginPassword = () => {
  const { t } = useTranslation([i18nNS.AUTH, i18nNS.COMMON, i18nNS.GLOSSARY]);

  const { formMethods, onSubmit, handleBack, session, acadlySignupUrl } = useLoginPasswordVM();

  const { handleSubmit, control, formState } = formMethods;
  const { isSubmitting } = formState;

  return (
    <Layout title={t('welcome_back', { ns: i18nNS.AUTH })} canSeeUserCell>
      <Stack gap={6} component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
        <Stack gap={3} alignItems="flex-start">
          <input readOnly type="email" autoComplete="username" value={session?.email} hidden />
          <StyledPasswordTextField
            control={control}
            name="password"
            label={t('password', { ns: i18nNS.GLOSSARY })}
            required
            size="medium"
            placeholder={t('enter_your_password_here', { ns: i18nNS.AUTH })}
            autoComplete="current-password"
            fullWidth
            autoFocus
          />
        </Stack>
        <Link
          href={acadlySignupUrl}
          aria-label={t('click_to_go_to_forgot_password_page', { ns: i18nNS.AUTH })}
          variant="textSmMedium"
          sx={{ alignSelf: 'flex-start' }}
        >
          {t('forgot_password', { ns: i18nNS.AUTH })}
        </Link>
        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={5} component="footer">
          <BackButton
            size="medium"
            onClick={handleBack}
            aria-label={t('click_to_go_back', { ns: i18nNS.COMMON })}
          >
            {t('back', { ns: i18nNS.GLOSSARY })}
          </BackButton>
          <LoginButton
            type="submit"
            size="medium"
            isLoading={isSubmitting}
            aria-label={t('click_to_login', { ns: i18nNS.AUTH })}
          >
            {t('login', { ns: i18nNS.GLOSSARY })}
          </LoginButton>
        </Stack>
      </Stack>
    </Layout>
  );
};

export default LoginPassword;
